export const AppwideDrawerContentType = {
  TransferForm: 'TransferForm',
  ResolveReconMismatches: 'ResolveReconMismatches',
  CustomerSettlement: 'CustomerSettlement',
  AutoHedgePositionRule: 'AutoHedgePositionRule',
  EntityAdmin: 'EntityAdmin',
  TradeEntry: 'TradeEntry',
  ThemeColorGeneration: 'ThemeColorGeneration',
  CreateCustomerDeposit: 'CreateCustomerDeposit',
  CustomerBalanceTransaction: 'CustomerBalanceTransaction',
  InstrumentInspector: 'InstrumentInspector',
  IndexMarkEditor: 'IndexMarkEditor',
  ModifyAssetTransaction: 'ModifyAssetTransaction',
  ABORReconComment: 'ABORReconComment',
} as const;
export type AppwideDrawerContentType = (typeof AppwideDrawerContentType)[keyof typeof AppwideDrawerContentType];
